<template>
  <div class="chat-window">
    <div class="chat-messages" id="chatArea">
      <div id="messages" v-for="(item, index) in orderNotes" :key="index">
        <div class="userName" v-if="item.from.name !== currentUser">
          {{
            item.from.role === "ADMIN"
              ? item.order.client.clientGroup.name
              : "窓口担当"
          }}&nbsp;&nbsp;
          {{ item.from.name }}
        </div>
        <ChatBaloon
          :key="item.id"
          :headerIcon="item.from.avatarImageUrl"
          :body="item.body"
          :currentUser="currentUser"
          :user="item.from.name"
        />
        <div :class="currentUser === item.from.name ? 'footer' : 'footerRight'">
          {{ item.createdAt | humanize.date }}
        </div>
      </div>
    </div>
    <div class="chat-input">
      <el-input
        class="messageInputColumn"
        type="textarea"
        autosize
        placeholder="編集履歴を入力してください"
        v-model="body"
      ></el-input>
      <el-button
        size="small"
        class="submitButtonColumn"
        type="primary"
        @click="_onClickCreateOrderNote()"
        >送信</el-button
      >
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import ChatBaloon from "@/components/ChatBaloon.vue";
import UsecaseFactory from "@/usecases/usecase.factory.js";
import Auth from "@/services/auth.service";

const orderNoteUsecase = UsecaseFactory.create("orderNote");
const authService = new Auth();

export default {
  components: {
    ChatBaloon,
  },
  async created () {
    this.updateMessages();
  },
  computed: mapState({}),
  data () {
    return {
      orderNotes: [],
      body: "",
    };
  },
  updated () {
    this.scrollToBottom();
  },
  methods: {
    scrollToBottom () {
      this.$el.scrollTop = this.$el.clientHeight;
    },
    async updateMessages () {
      const user = await authService.getCurrentUser();
      this.currentUser = user.attributes.name;
      const orderId = this.$route.params.id ? this.$route.params.id : "";
      const orderNotes = await orderNoteUsecase.getOrderNotes({ orderId });
      this.orderNotes = orderNotes.reverse();
    },
    initMessageInput () {
      this.body = "";
    },
    async _onClickCreateOrderNote () {
      // Validation
      if (this.body === "") {
        alert("本文を入力してください");
        return;
      }

      const orderId = this.$route.params.id;
      const { body } = this;

      // Send
      const sentMessage = await orderNoteUsecase.sendOrderNote({
        orderId,
        body,
      });

      // Cleanup
      if (sentMessage) {
        this.initMessageInput();
        this.updateMessages();
        return;
      }

      // Failed to send
      alert("送信に失敗しました。再度お試しください");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";

.chat-window {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.chat-messages {
  flex: 1;
  height: 100%;
  overflow: auto;
  display: flex;
  flex-direction: column-reverse;
}
.chat-input {
  border-top: 1px solid $--border-color-lighter;
  padding: 1rem 2rem 0 1.1rem;
}
.messageInputColumn {
  flex: 1;
  width: 105%;
}
.submitButtonColumn {
  width: 5rem;
  margin-top: 0.5rem;
  float: right;
  margin-right: -2rem;
}
.userName {
  margin-left: 20px;
  font-size: 13px;
}
.footerRight {
  width: 55%;
  line-height: 1;
  float: left;
  margin-left: 1.5rem;
  margin-bottom: 1.5rem;
  text-align: end;
  font-size: 13px;
}
.footer {
  width: 55%;
  line-height: 1;
  float: right;
  margin-right: 1.5rem;
  margin-bottom: 1.5rem;
  text-align: end;
  font-size: 13px;
}
</style>
